var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('not-authenticated',[_c('v-card',{staticClass:"elevation-0 mx-auto login-area-box",attrs:{"color":"transparent","flat":""}},[_c('h1',{staticClass:"subtitle-1 mediumGray--text text-center mb-6"},[_vm._v(" Acessar plataforma ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }